export const scoreToColor = (score) => {
  if (score < 40) {
    return 'rgb(246, 60, 45)';
  } else if (score < 81) {
    return 'rgb(249, 104, 0)';
  }
  return 'rgb(5, 170, 57)';
};

export const scoreToStatusText = (score) => {
  if (score < 40) {
    return '可能有疾病';
  } else if (score < 81) {
    return '亚健康';
  }
  return '健康';
};

export const symptomNameTranslate = n => (
  n === '健康' ? '健康' : n
);

export const addClass = (el, className) => {
  if (hasClass(el, className)) return;
  if (el.classList) el.classList.add(className);
  else el.className += ` ${className}`;
};

export const removeClass = (el, className) => {
  if (!hasClass(el, className)) return;
  if (el.classList) el.classList.remove(className);
  else {
    el.className = el.className.replace(
      new RegExp(`(^|\\b)${className.split(' ').join('|')}(\\b|$)`, 'gi'),
      ' '
    );
  }
};

export const hasClass = (el, className) => {
  if (el.classList) { return el.classList.contains(className); }
  return new RegExp(`(^| )${className}( |$)`, 'gi').test(el.className);
};

export const setClass = (el, className, on) => {
  if (on) addClass(el, className);
  else removeClass(el, className);
};

export const calculateBMI = (height, weight) => {
  const bmi = weight / (height / 100.0) / (height / 100.0);
  let text;
  if (bmi < 18.5) {
    text = '过轻';
  } else if (bmi < 24) {
    text = '正常';
  } else if (bmi < 27) {
    text = '过重';
  } else if (bmi <= 32) {
    text = '肥胖';
  } else {
    text = '非常肥胖';
  }
  return {
    bmi, text
  };
};



// WEBPACK FOOTER //
// ./src/components/util.js